import {ff, form, Form, FormActions, FormBody, field} from "@mc/mc-legacy";
import {Col, PrimaryButton, Row} from "@mc/ui-v3";
import React from "react";
import {connect} from "react-redux";
import {Button} from "reactstrap";
import {reduxForm} from "redux-form";
import EnumPage from "../../api/gen/qsign/types/EnumPage";
import GraphicSealState from "../../api/gen/qsign/types/GraphicSealState";

const validate = (formData) => {
    const errors = {};

    if (!formData.page) {
        errors.page = "Umístění musí být vyplněné";
    }
    if (!formData.positionX) {
        errors.positionX = "Pozice X musí být vyplněná";
    }
    if (!formData.positionY) {
        errors.positionY = "Pozice Y musí být vyplněná";
    }
    if (!formData.height) {
        errors.height = "Výška musí být vyplněná";
    }
    if (!formData.width) {
        errors.width = "Šířka musí být vyplněná";
    }
    if (!formData.insertSeal) {
        errors.insertSeal = "musí být vyplněn";
    }
    return errors;
};

const items = [
    {id: EnumPage.FIRST, name: "První"},
    {id: EnumPage.LAST, name: "Poslední"},
];

const SealStateitems = [
    {id: GraphicSealState.NOT_CONFIGURED, name: "Nenastaveno"},
    {id: GraphicSealState.TRUE, name: "Výchozí zapnuto"},
    {id: GraphicSealState.FALSE, name: "Výchozí vypnuto"},
];

class PecetForm extends React.Component {
    static formName = "PecetForm";

    render() {
        const {handleSubmit, submitting} = this.props;

        return (
            <div className="w-100 d-flex justify-content-center">
                <Col xs={5} className="d-flex mt-2">
                    <form>
                        <FormBody>
                            <ff.Autocomplete disabled={submitting} required name="page" label="Umístění" items={items}
                                             useIdAsValue={true}/>
                            <Row>
                                <Col xs={6}>
                                    <ff.Number disabled={submitting} required name="positionX" label="Pozice X"/>
                                </Col>
                                <Col xs={6}>
                                    <ff.Number disabled={submitting} required name="positionY" label="Pozice Y"/>
                                </Col>
                                <Col xs={6}>
                                    <ff.Number disabled={submitting} required name="width" label="Šířka"/>
                                </Col>
                                <Col xs={6}>
                                    <ff.Number disabled={submitting} required name="height" label="Výška"/>
                                </Col>
                            </Row>
                            <ff.Autocomplete
                                disabled={submitting}
                                required
                                name="graphicSealState"
                                label="Konfigurace"
                                items={SealStateitems}
                                useIdAsValue={true}
                            />
                            <Button color="primary" className="mt-2" onClick={handleSubmit}>
                                Aktualizovat
                            </Button>
                        </FormBody>
                    </form>
                </Col>
            </div>
        );
    }
}

function mapStateToProps(state) {
}

export default connect(mapStateToProps)(
    reduxForm({
        initialValues: {},
        form: PecetForm.formName,
        validate: validate,
    })(PecetForm)
);
